import { Dialog, Transition } from "@headlessui/react";
import type { FC, ReactNode } from "react";
import { Fragment } from "react";
import { cx } from "../../utils";

interface ModalProps {
  opened: boolean;
  onClose: () => void;
  children: ReactNode;
  panelClassName?: string;
  zIndex?: number;
  backdropClassName?: string;
}

export const Modal: FC<ModalProps> = ({
  opened,
  onClose,
  children,
  panelClassName,
  zIndex = 50,
  backdropClassName
}) => {
  return (
    <Transition appear show={opened} as={Fragment}>
      <Dialog
        as="div"
        className="relative"
        onClose={onClose}
        style={{
          zIndex
        }}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            aria-hidden="true"
            className={cx("fixed inset-0 bg-alpha-400", backdropClassName)}
          />
        </Transition.Child>

        <div className="fixed inset-0 flex items-center justify-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel
              className={cx("rounded-lg bg-background-1000", panelClassName)}
            >
              {children}
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};
